import { Form } from "@circle-react-uikit/Form";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import { SettingsSection } from "./SettingsSection";
import { SettingsSectionBody } from "./SettingsSectionBody";

export const EngagementSection = () => {
  const { watch } = useFormContext<PostFormValues>();
  const isCommentsDisabled = watch("is_comments_disabled");

  return (
    <SettingsSection title={t("quick_post_v3.settings.sections.engagement")}>
      <SettingsSectionBody>
        <Form.ToggleSwitch
          name="is_comments_disabled"
          label={t("post.is_comments_disabled")}
          labelPosition="end"
        />
        {!isCommentsDisabled && (
          <Form.ToggleSwitch
            name="is_comments_closed"
            label={t("post.is_comments_closed")}
            labelPosition="end"
          />
        )}
        <Form.ToggleSwitch
          name="is_liking_disabled"
          label={t("post.is_liking_disabled")}
          labelPosition="end"
        />
      </SettingsSectionBody>
    </SettingsSection>
  );
};
